import { Tabs, TabsList, TabsTrigger } from "@/components/ui/Tabs";
import type { ProductKind } from "../lib/stockHealth";

interface Props {
  value: ProductKind;
  onChange: (next: ProductKind) => void;
  counts: Record<ProductKind, number>;
}

const TABS: { kind: ProductKind; label: string }[] = [
  { kind: "for_sale", label: "For sale" },
  { kind: "gift", label: "Gifts" },
  { kind: "not_moving", label: "Not moving" },
];

// What each tab holds, spelled out beside the tabs.
const LEGEND: Record<ProductKind, string> = {
  for_sale: "Sold or gifted in the last 90 days, less than 90% as gifts.",
  gift: "90% or more of the units in the last 90 days went out as gifts.",
  not_moving: "Nothing sold or gifted in the last 90 days. New: first in stock in the last 90 days.",
};

// Splits the stock list by how it moved over the last 90 days (see
// Inventory::StockHealth), with the open tab's rule beside the tabs in the
// same box.
export default function ProductKindTabs({ value, onChange, counts }: Props) {
  return (
    <Tabs value={value} onValueChange={(next) => onChange(next as ProductKind)}>
      <div className="inline-flex max-w-full flex-wrap items-center gap-x-4 gap-y-1 rounded-lg border border-border bg-background p-1">
        <TabsList variant="segmented" className="border-0 p-0">
          {TABS.map((tab) => (
            <TabsTrigger key={tab.kind} value={tab.kind} variant="segmented">
              {tab.label} ({counts[tab.kind].toLocaleString()})
            </TabsTrigger>
          ))}
        </TabsList>
        <p className="px-2 text-sm text-foreground">{LEGEND[value]}</p>
      </div>
    </Tabs>
  );
}
